import { render, staticRenderFns } from "./ExternalAccessArticlePage.vue?vue&type=template&id=613debb3&"
import script from "./ExternalAccessArticlePage.vue?vue&type=script&lang=ts&"
export * from "./ExternalAccessArticlePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports